import * as React from "react";

const BackToProduct = () => {
  /**
   * author : tusharKc
   * changes: using history.back(), to dynamically route the user
   * to the previous route,  instead of the static plp route
   * ticket: 9077
   *
   */

  return (
    <>
      <a
        href={void 0}
        disabled={window?.parent?.navigation?.canGoBack === false}
        className={`back-btn ${window?.parent?.navigation?.canGoBack === false ? ' link-disabled': ''}`}
        onClick={() => history.back()}
      >
        <i className="fa fa-angle-left" /> BACK TO PRODUCTS
      </a>
    </>
  );
};

export default BackToProduct;
